import { render, staticRenderFns } from "./ChatCreditWarning.vue?vue&type=template&id=3801d211&scoped=true&"
import script from "./ChatCreditWarning.vue?vue&type=script&lang=js&"
export * from "./ChatCreditWarning.vue?vue&type=script&lang=js&"
import style0 from "./ChatCreditWarning.vue?vue&type=style&index=0&id=3801d211&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801d211",
  null
  
)

export default component.exports